import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const Card = ({ url, imageUrl, imageAlt, title, description, target }) => {
  const cardContent = (
    <>
      <picture className="tab-faceted-listing__card-image">
        <source srcSet={`${imageUrl}?format=webp`} type="image/webp" />
        <img src={imageUrl} alt={imageAlt} loading="lazy" />
      </picture>
      <div className="tab-faceted-listing__card-content">
        <p className="tab-faceted-listing__card-title">{parse(title)}</p>
        {!!description && (
          <div className="tab-faceted-listing__card-description rtf">
            {parse(description)}
          </div>
        )}
        {!!url && (
          <div class="tab-faceted-card-arrow">
            <span className="cta-decorator-v2 cta-decorator-v2--angle bg-dark">
              <svg viewBox={`0 0 ${target === '_blank' ? '19 18' : '19 18'}`}>
                <use
                  xlinkHref={`#${
                    target === '_blank' ? '' : ''
                  }link-arrow-icon`}
                />
              </svg>
            </span>
          </div>
        )}
      </div>
    </>
  );

  return url ? (
    <a href={url} className="tab-faceted-listing__card" target={target}>
      {cardContent}
    </a>
  ) : (
    <div className="tab-faceted-listing__card">{cardContent}</div>
  );
};

Card.propTypes = {
  url: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  target: PropTypes.string
};

export default Card;
